import type { RenderedView } from '../router.js';
import { navigate } from '../router.js';
import { repos } from '../store.js';
import { qs, toast } from '../dom.js';
import { icon } from '../icons.js';
import { loadLayout } from '../../forms.js';
import { ScanController } from '../scanController.js';
import { ingestRawResponse } from '../../db/scanService.js';

export async function scanPapersView(params: Record<string, string>): Promise<RenderedView> {
  const assignment = await repos.getAssignment(params.id);
  if (!assignment) return { title: 'Scan', back: '/quizzes', html: `<div class="view"><p class="empty">Assignment not found.</p></div>` };
  const quiz = (await repos.getQuiz(assignment.quizId))!;
  const [layout, key, students, cls] = await Promise.all([
    loadLayout(quiz.items),
    repos.answerKeyFor(quiz.id),
    repos.studentsInClass(assignment.classId),
    repos.getClass(assignment.classId),
  ]);
  let ctrl: ScanController | null = null;

  return {
    title: 'Scan papers',
    subtitle: `${quiz.title} · ${cls?.name ?? ''}`,
    back: `/quiz/${quiz.id}`,
    action: { label: 'Review', icon: icon.list(), href: `/assignment/${assignment.id}/review` },
    html: `<div class="view view-flush" id="scanRoot"></div>`,
    unmount: () => ctrl?.dispose(),
    mount(root) {
      const mode = assignment.identificationMode ?? 'roster';
      ctrl = new ScanController(qs(root, '#scanRoot')!, {
        layout,
        mode: 'papers',
        identificationMode: mode,
        keyForScoring: key,
        students,
        onSave: async (raw, identity) => {
          const out = await ingestRawResponse(repos, assignment, raw, identity);
          const who = identity.capturedName
            ? identity.capturedName
            : identity.studentId
              ? students.find((s) => s.id === identity.studentId)?.name ?? 'student'
              : `#${out.result.idDigitsRead || '—'}`;
          const scoreTxt = out.scored ? ` — ${out.scored.score}/${out.scored.maxScore}` : '';
          toast(`Saved: ${who}${scoreTxt}${out.result.needsReview ? ' (needs review)' : ''}`);
          ctrl!.start(); // straight to the next paper
        },
      });
      ctrl.start();
    },
  };
}
